import calendarData from './calendar-data';

/**
 * Provides calendar information for a country, including firstDay, weekendStart, and weekendEnd.
 * @param {string} country - The ISO-3166 2-letter country code
 * @return {object} Return
 */
export default function getCalendarInfo(country) {
  const upperCaseCountry = typeof country === 'string' ? country.toUpperCase() : country;
  return {
    firstDay: calendarData.firstDay[upperCaseCountry] || 'monday',
    weekendStart: calendarData.weekendStart[upperCaseCountry] || 'friday',
    weekendEnd: calendarData.weekendEnd[upperCaseCountry] || 'sunday',
  };
}
